import React from 'react';
import { Link } from 'react-router-dom';
import {Button, useSavingsAuth} from 'savings-js';
import '../App.css';

// Environment info component
const EnvInfo = () => {
  return (
    <div style={{ 
      backgroundColor: '#f0f0f0', 
      padding: '15px', 
      borderRadius: '5px',
      marginTop: '20px'
    }}>
      <h3>Environment Information</h3>
      <p>Node Environment: {process.env.NODE_ENV}</p>
      <p>API URL: {process.env.REACT_APP_API_URL || 'Default API URL'}</p>
    </div>
  );
};

const Home: React.FC = () => {
  const { getUser } = useSavingsAuth();
  const user = getUser();

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto' 
    }}>
      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
      }}>
        <h2>Welcome to Incentives Configuration</h2>
        
        {user && (
          <div style={{ marginTop: '20px' }}>
            <h3>User Information</h3>
            <p><strong>Name:</strong> {user.name} {user.lastName}</p>
            <p><strong>Email:</strong> {user.email}</p>
          </div>
        )}
        
        <EnvInfo />
        
        <div style={{ marginTop: '30px' }}>
          <h3>Manage Incentive Programs</h3>
          <p>Configure and manage incentive programs for partners.</p>
          <Link to="/programs">
            <Button 
              label="View Programs"
              color="primary"
              className="mt-3"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home; 